export const getIsAuth = state => state.authState;
